import { FeatureName } from '@bybeam/platform-types';
import Button from '@platform-ui-common/components/Button/index.js';
import FormContainer from '@platform-ui-common/components/FormContainer/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import usePartnerPrograms from '@platform-ui-common/hooks/contexts/PartnerPrograms/index.js';
import useProgram from '@platform-ui-common/hooks/contexts/useProgram.js';
import Color, { BackgroundColors } from '@platform-ui-common/utilities/Color.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import useLogout from '@platform-ui/auth/hooks/useLogout.js';
import { checkFeatureAnyProgram } from '@platform-ui/utilities/checkFeature.js';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Callout, Link } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom-v5-compat';
import ApplicantRoutes from '../../utils/ApplicantRoutes.js';
import FollowupSteps from './components/FollowupSteps.js';
import OtherPrograms from './components/OtherPrograms.js';

export default function SubmissionConfirmation(): JSX.Element {
  const { logout, loading } = useLogout();
  const program = useProgram();
  const { programs } = usePartnerPrograms();
  const { user } = useAuth();
  const navigate = useNavigate();

  const isAnonymous = user?.core?.isAnonymous ?? false;

  return (
    <FormContainer
      title="Thanks for applying"
      buttons={
        <div className="w-full flex flex-col gap-y-4 items-center">
          {isAnonymous ? (
            <Button
              className={`${BackgroundColors[Color.Brand]}`}
              link={ApplicantRoutes.PROFILE}
              variant="outline"
            >
              Link Your Account
            </Button>
          ) : (
            <Button
              className={`${BackgroundColors[Color.Brand]}`}
              onClick={logout}
              disabled={loading}
              variant="outline"
            >
              Log Out
            </Button>
          )}
          <Button link={ApplicantRoutes.APPLICATION_PORTAL}>View Application Status</Button>
        </div>
      }
    >
      <div className="mb-4">
        <Typography variant="largeBody">
          We have received your application for the {program.name}.
        </Typography>
      </div>
      <FollowupSteps program={program} />
      {checkFeatureAnyProgram(programs, FeatureName.ProgramsReferral) && <OtherPrograms />}
      {isAnonymous ? (
        <Callout.Root color="yellow" highContrast role="alert" size="3">
          <Callout.Icon>
            <ExclamationTriangleIcon />
          </Callout.Icon>
          <Callout.Text>
            <Link href="#" onClick={() => navigate(ApplicantRoutes.PROFILE)}>
              Link your account
            </Link>{' '}
            so you can keep access across devices and receive updates.
          </Callout.Text>
        </Callout.Root>
      ) : null}
    </FormContainer>
  );
}
